import { createContext, useCallback, useContext } from 'react';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { VerticalMenuIcon } from 'foundations-assets';
import Raven from 'raven-js';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const ContextMenuHandlerContext = /*#__PURE__*/createContext({});
export const ProvideContextMenuHandler = ({
  onContextMenu,
  children
}) => {
  return /*#__PURE__*/_jsx(ContextMenuHandlerContext.Provider, {
    value: {
      onContextMenu
    },
    children: children
  });
};
export const useIsContextMenuEnabled = () => {
  const {
    onContextMenu
  } = useContext(ContextMenuHandlerContext);
  return Boolean(onContextMenu);
};
export const useContextMenuHandler = ({
  columnName,
  columnNamespace,
  row
}) => {
  const {
    onContextMenu
  } = useContext(ContextMenuHandlerContext);
  const handleContextMenu = useCallback(event => {
    if (onContextMenu) {
      const targetElement = row ? event.currentTarget : event.currentTarget.closest('th');
      if (!targetElement) {
        const error = new Error('No target element found when triggering the context menu');
        Raven.captureException(error);
        //rather than early return or throw an error, we'll log the error and continue
        //this will result in the context menu appearing in the wrong place, but its better than crashing
        //or not showing at all
        //This is a defensive, graceful fallback, as opposed to an expected runtime situation
      }
      const {
        hasMenu
      } = onContextMenu({
        columnName,
        columnNamespace,
        row,
        targetElement: targetElement
      });
      if (hasMenu) {
        event.preventDefault();
      }
    }
  }, [onContextMenu, columnName, columnNamespace, row]);
  return handleContextMenu;
};
export const ContextMenuTriggerButton = ({
  columnNamespace,
  columnName
}) => {
  const {
    onContextMenu
  } = useContext(ContextMenuHandlerContext);
  const handleContextMenu = useContextMenuHandler({
    columnNamespace,
    columnName
  });
  const handleClick = useCallback(e => {
    //TODO - we should eventually update the types to support more than HTMLTableCellElements, we dont
    //leverage anything that requires the type to be HTMLTableCellElement
    handleContextMenu(e);
  }, [handleContextMenu]);
  if (!onContextMenu) {
    return null;
  }
  return /*#__PURE__*/_jsx(IconButton, {
    "aria-label": I18n.text('datatable.contextMenu.openContextMenu'),
    onClick: handleClick,
    size: "extra-small",
    children: /*#__PURE__*/_jsx(VerticalMenuIcon, {})
  });
};